import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_icon_addfavorite from "@/Globals/_images/icons/AddFavorite.png";
import img_icon_favorite from "@/Globals/_images/icons/Favorite.png";

interface FavoriteControlProps {
    onChange: (isFavorite: boolean) => void;
    isFavoriteSet: boolean;
    imageStyles?: React.CSSProperties;
}

class FavoriteControl extends BaseReactComponent<FavoriteControlProps, null> {
    public render(): JSX.Element {
        const imageStyles = this.props.imageStyles ?? {};
        const imageSrc = this.props.isFavoriteSet
            ? img_icon_favorite
            : img_icon_addfavorite;

        return (
            <div
                className="pointer"
                onClick={e => {
                    e.stopPropagation();
                    this.props.onChange(!this.props.isFavoriteSet);
                }}
            >
                <img
                    style={imageStyles}
                    src={imageSrc}
                />
            </div>
        );
    }
}

export { FavoriteControl };
